import React from 'react';
import type { HourlyForecast } from '../../types/weather';
import type { TemperatureUnit } from '../../utils/temperatureUnit';
import { formatTemp } from '../../utils/temperatureUnit';
import { resolveHourlyIcon } from '../../utils/weatherIcons';
import WeatherConditionIcon from './WeatherConditionIcon';
import styles from './HourlyWeatherStrip.module.css';

export interface HourlyWeatherStripProps {
  hours: HourlyForecast[];
  unit: TemperatureUnit;
}

function formatHourLabel(hour: number): string {
  if (hour === 0) return '12a';
  if (hour < 12) return `${hour}a`;
  if (hour === 12) return '12p';
  return `${hour - 12}p`;
}

const HourlyWeatherStrip: React.FC<HourlyWeatherStripProps> = ({ hours, unit }) => {
  if (hours.length === 0) {
    return null;
  }

  return (
    <div className={styles.strip} data-testid="hourly-weather-strip">
      {hours.map((hour) => {
        const iconName = resolveHourlyIcon(hour.iconName, hour.precipProbability);
        return (
          <div key={`${hour.date}-${hour.hour}`} className={styles.cell}>
            <span className={styles.hour}>{formatHourLabel(hour.hour)}</span>
            <WeatherConditionIcon iconName={iconName} size={18} className={styles.icon} />
            <span className={styles.temp}>{formatTemp(hour.tempC, unit)}</span>
            {hour.precipProbability > 0 ? (
              <span className={styles.precip}>{Math.round(hour.precipProbability)}%</span>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default HourlyWeatherStrip;
